import { Component, Input, OnInit } from "@angular/core";
import { MutuelleAttestationPatient } from "@jack-sparrow-libraries/emotion-models";
import { MatDialogRef } from "@angular/material/dialog";
import { SignConventionActionsEnum } from "features";

@Component({
	standalone: false,
	selector: "cba-sign-convention-alert-modal",
	templateUrl: "./sign-convention-alert-modal.component.html",
	styleUrls: ["./sign-convention-alert-modal.component.scss"],
})
export class SignConventionAlertModalComponent implements OnInit {
	@Input() isInterAmc = false;
	@Input() mutuelle: MutuelleAttestationPatient;
	title;
	subtitle;
	constructor(public dialogRef: MatDialogRef<SignConventionAlertModalComponent>) {}

	ngOnInit() {
		if (this.isInterAmc) {
			this.title = "Il semblerait que tu n’aies pas signé de convention avec les mutuelles de l’Inter-AMC. ";
		} else {
			this.title = `Il semblerait que tu n’aies pas signé de convention avec la mutuelle ${this.mutuelle?.nom}.`;
		}
	}

	signConvention() {
		window.open("https://www.tpcomplementaire.fr/iamcpublic/index.html", "_blank");
	}

	onCancel() {
		this.dialogRef.close(SignConventionActionsEnum.SIGN_LATER);
	}

	alreadySigned() {
		if (this.isInterAmc) {
			this.dialogRef.close(SignConventionActionsEnum.ALREADY_CONVENTION_SIGNED_INTER_AMC);
		} else {
			this.dialogRef.close(SignConventionActionsEnum.ALREADY_CONVENTION_SIGNED);
		}
	}
}
